/**
 * The AI panel's standing "what's sent" disclosure (GDPR Art. 13), built from
 * the locale files so it exists in en AND de.
 *
 * Every sentence here is a factual claim about the code and must stay true:
 *   - response bodies cross only while "Let AI read responses" is on
 *     (services/ai/responseAccess.js), redacted first;
 *   - DB Manager rows NEVER cross: `db_run_sql` hands the model only
 *     { executed, row_count, columns:[{name}] } (AIChatPanel `condenseToolResultForApi`,
 *     toolSchemas.js DB_TOOLS); a failed query's error has quoted values
 *     replaced (services/ai/dbErrorScrub.js); the DB grid's "Explain this error"
 *     prefill carries the SQL and the error, never a row. There is no approval
 *     that sends rows — do not reintroduce "unless you approve it". Rows the
 *     assistant prints via terminal_run_command are "command output", disclosed
 *     in the first sentence.
 *   - "your own API key" only when the turn really goes to a BYO provider.
 */
export function buildWhatIsSentText(t, via) {
  const opening = via === 'apiboo'
    ? t('aiChat.whatIsSent.sentToApiboo')
    : t('aiChat.whatIsSent.sentToProvider');
  return [
    opening,
    t('aiChat.whatIsSent.responseBodies', { toggle: t('settings.aiReadResponses') }),
    t('aiChat.whatIsSent.dbRows'),
    t('aiChat.whatIsSent.secrets'),
  ].join(' ');
}
